import { excludeRoutes } from '@portal/constants/locations';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { LocaleEnum } from 'schema/locale';
import { getCanonicalLink } from '../utils/getCanonicalLink';
import { getSafeLocale } from '../utils/locale';

type Props = {
  href?: string | null;
};

export const CanonicalLink = ({ href: hrefProp }: Props) => {
  const router = useRouter();

  const href = useMemo(() => {
    if (hrefProp) {
      return hrefProp;
    }

    const safeLocale = getSafeLocale(router.locale);

    const isExcluded = excludeRoutes.some((route) => router.asPath.startsWith(route));
    if (isExcluded) {
      return getCanonicalLink(router.asPath, LocaleEnum.enUS);
    }

    return getCanonicalLink(router.asPath, safeLocale);
  }, [hrefProp, router.locale, router.asPath]);

  return (
    <Head>
      <link key="canonical" rel="canonical" href={href} />
    </Head>
  );
};
